import React, { useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "../styles/Z1.css";

// ⭐ Example 5 rows data – replace with your images, headings & text
import img1 from "../assets/images/item7/subitm1.jpg";
import img2 from "../assets/images/item7/subitm2.jpg";
import img3 from "../assets/images/item7/subitm3.jpg";
import img4 from "../assets/images/item7/subitm4.jpg";
import img5 from "../assets/images/item7/subitm5.jpg";
import img6 from "../assets/images/item7/subitm6.jpg";
import img7 from "../assets/images/item7/subitm7.jpg";

const rowsData = [
  {
    id: 1,
    title: "Sheet Metal (Coils & Plates)",
    text: "Durable sheet metal for fabrication and industrial applications.",
    img: img1,
    gradient: "gradient1",
    stars: 4,
    description: `Sheet metal is widely used in construction, automotive, and manufacturing industries. It can be cut, bent, or welded into a variety of shapes. Available in steel, aluminum, and other metals for different needs.`
  },
  {
    id: 2,
    title: "Metal Profile (Pipes, Rods, Bars)",
    text: "Precision metal profiles for structural and industrial use.",
    img: img2,
    gradient: "gradient2",
    stars: 5,
    description: `Metal profiles provide structural support in construction and machinery. Available in different shapes such as angles, channels, and beams. Made from high-quality steel, aluminum, or stainless steel.`
  },
  {
    id: 3,
    title: "Fasteners (Bolts, Nuts, Washers)",
    text: "Reliable fasteners for secure mechanical and structural connections.",
    img: img3,
    gradient: "gradient3",
    stars: 3,
    description: `Fasteners such as bolts, nuts, and screws join materials securely. Made from high-strength steel or stainless steel for durability. Available in various sizes and finishes for different applications.`
  },
  {
    id: 4,
    title: "Perforated Sheet Metal",
    text: "High-quality perforated sheet metal for ventilation and design applications.",
    img: img4,
    gradient: "gradient4",
    stars: 4,
    description: `Perforated sheet metal features evenly spaced holes for airflow and aesthetics. Made from stainless steel, aluminum, or mild steel. Used for filters, guards, and decorative panels.`
  },
  {
    id: 5,
    title: "Grease",
    text: "Premium industrial grease for smooth machinery operation and protection.",
    img: img5,
    gradient: "gradient5",
    stars: 5,
    description: `FIndustrial grease lubricates moving parts to reduce friction and wear. Protects equipment from rust, corrosion, and high temperatures. Available in various grades for automotive and heavy machinery.
`
  },
  {
    id: 6,
    title: "Bearings",
    text: "High-performance bearings for smooth rotation and reduced friction.",
    img: img6,
    gradient: "gradient4",
    stars: 4,
    description: `Bearings enable smooth motion and support rotating parts in machinery. Made from high-grade steel for strength and long life. Available in ball, roller, and needle bearing types.`
  },
  {
    id: 7,
    title: "Industrial Valves",
    text: "Reliable industrial valves for precise flow control in piping systems.",
    img: img7,
    gradient: "gradient5",
    stars: 5,
    description: `Industrial valves regulate the flow of liquids, gases, or steam. Available in gate, ball, check, and butterfly valve types. Manufactured from durable metals to handle high pressure and temperature.`
  }
];

function Z7() {
  const [selectedRow, setSelectedRow] = useState(null);

  return (
    <>
      <Navbar />

      <section className="z1-section">
        {rowsData.map((row) => (
          <div
            key={row.id}
            className={`z1-row ${row.gradient}`}
            onClick={() => setSelectedRow(row)}
          >
            <div className="z1-img">
              <img src={row.img} alt={row.title} />
            </div>

            <div className="z1-content">
              <h2>{row.title}</h2>
              <p>{row.text}</p>
              <div className="stars">
                {"★".repeat(row.stars)}
                {"☆".repeat(5 - row.stars)}
              </div>
            </div>
          </div>
        ))}
      </section>

      {/* 🔹 Popup / Modal */}
      {selectedRow && (
        <div className="z1-modal-overlay" onClick={() => setSelectedRow(null)}>
          <div
            className="z1-modal"
            onClick={(e) => e.stopPropagation()} // prevent close on inner click
          >
            <h2>{selectedRow.title}</h2>

            <div className="modal-body">
              <div className="modal-img">
                <img src={selectedRow.img} alt={selectedRow.title} />
              </div>
              <div className="modal-text">
                <p>{selectedRow.description}</p>
              </div>
            </div>

            <button
              className="close-btn"
              onClick={() => setSelectedRow(null)}
            >
              Close
            </button>
          </div>
        </div>
      )}

      <Footer />
    </>
  );
}

export default Z7;